export default __webpack_public_path__ + "static/media/BONIAL_FR.6149e4b5.png";